import { render, staticRenderFns } from "./SaveCustomerForm.vue?vue&type=template&id=4695f8fd&"
import script from "./SaveCustomerForm.vue?vue&type=script&lang=js&"
export * from "./SaveCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports